import React, { ReactElement } from "react";
import LoginForm from "./LoginForm";
import Info from "./Info";

interface Props {
  setUser: any;
}

export default function Login({ setUser }: Props): ReactElement {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "red",
        minWidth: "100vw",
        minHeight: "100vh",
      }}
    >
      <Info />
      <LoginForm setUser={setUser} />
    </div>
  );
}
